/**
 * 物理エンジンの版。結果が変わる変更（式・既定値・積分方式）では更新し、
 * 回帰テストの差分を PR に記載する（docs/physics/physics-model.md 13 章）。
 */
export const PHYSICS_ENGINE_VERSION = '0.5.0';
